// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen,
  FilterAdd
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  Related_Products: FilterAdd,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const product: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="product Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [
    {
      id: 'category',
      title: <FormattedMessage id="category" />,
      type: 'collapse',
      icon: icons.category,
      children: [
        {
          id: 'category-list',
          title: <FormattedMessage id="category-list" />,
          type: 'item',
          url: '/apps/category/category-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-category',
          title: <FormattedMessage id="add-new-category" />,
          type: 'item',
          url: '/apps/category/add-new-category'
        }
      ]
    },
    {
      id: 'filter',
      title: <FormattedMessage id="filter" />,
      type: 'collapse',
      icon: icons.filter,
      children: [
        {
          id: 'filter-list',
          title: <FormattedMessage id="filter-list" />,
          type: 'item',
          url: '/apps/filter/filter-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-filter',
          title: <FormattedMessage id="add-new-filter" />,
          type: 'item',
          url: '/apps/filter/add-new-filter'
        },
        {
          id: 'filterGroup-list',
          title: <FormattedMessage id="filterGroup-list" />,
          type: 'item',
          url: '/apps/filter/filterGroup-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-filterGroup',
          title: <FormattedMessage id="add-new-filterGroup" />,
          type: 'item',
          url: '/apps/filter/add-new-filterGroup'
        }
      ]
    },
    {
      id: 'Products',
      title: <FormattedMessage id="Products" />,
      type: 'collapse',
      icon: icons.Products,
      children: [
        {
          id: 'product-list',
          title: <FormattedMessage id="product-list" />,
          type: 'item',
          url: '/apps/Products/product-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-product',
          title: <FormattedMessage id="add-new-product" />,
          type: 'item',
          url: '/apps/Products/add-new-product'
        },
        {
          id: 'whole-sale-product-list',
          title: <FormattedMessage id="Whole Sale product-list" />,
          type: 'item',
          url: '/apps/Products/whole-sale-product-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-whole-sale-product',
          title: <FormattedMessage id="add-new-whole-sale-product" />,
          type: 'item', 
          url: '/apps/Products/add-new-whole-sale-product'
        }
      ]
    },
    {
      id: 'Related-Products',
      title: <FormattedMessage id="Related Products" />,
      type: 'collapse',
      icon: icons.Related_Products,
      children: [
        {
          id: 'related-products-list',
          title: <FormattedMessage id="Related products List" />,
          type: 'item',
          url: '/apps/Related-Products/related-products-list',
          breadcrumbs: false
        },
        {
          id: 'addRelatedProduct',
          title: <FormattedMessage id="Add Related Product" />,
          type: 'item',
          url: '/apps/Related-Products/addRelatedProduct'
        },
      ]
    },
    {
      id: 'Nutrition',
      title: <FormattedMessage id="Products Nutrition" />,
      type: 'collapse',
      icon: icons.Products,
      children: [
        {
          id: 'nutrition-list',
          title: <FormattedMessage id="Product Nutrition List" />,
          type: 'item',
          url: '/apps/Nutrition/nutrition-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-product-nutrition',
          title: <FormattedMessage id="Add New Product Nutrition" />,
          type: 'item',
          url: '/apps/Nutrition/add-new-product-nutrition'
        },
      ]
    },

    {
      id: 'update-price',
      title: <FormattedMessage id="update Price" />,
      type: 'collapse',
      icon: icons.update_purchase,
      children: [
        // {
        //   id: 'purchase-list',
        //   title: <FormattedMessage id="purchase-list" />,
        //   type: 'item',
        //   url: '/apps/purchase/purchase-list',
        //   breadcrumbs: false
        // },
        {
          id: 'update-price',
          title: <FormattedMessage id="update-price" />,
          type: 'item',
          url: '/apps/purchase/update-price'
        },
        
      ]
    },
  ]
};

export default product;
